import React from 'react';
import {Button, Col, Container, Form, Modal, Row} from "react-bootstrap";
import {Save, X} from "react-feather";
import {ContactForm, EmailForm, FirstNameForm, LastNameForm} from "../BenutzerManagement/NameForm";
import "../../Styles/OrganisationManagement/Organisation.css"

import "../../Styles/OrganisationManagement/BenutzerManagementSuperAdmin.css";

const NewOrganisationModal = (elem) => {
    return (
        <Modal size="lg" aria-labelledby="contained-modal-title-vcenter"
               centered
               animation={false}
               show={elem.props.addNewOrganisationModalShow}
               onHide={() => elem.resetState({addNewOrganisationModalShow: false})}
        >

            <Modal.Header closeButton>

                <Container>
                    <Row className="justify-content-md-center">
                        <Col sm="3">
                        </Col>
                        <Col sm="6"> <Modal.Title style={{textAlign: 'center'}}>Handwai | Organisation
                            Profile</Modal.Title></Col>
                        <Col sm="3">
                        </Col>
                    </Row>
                </Container>


            </Modal.Header>

            <Modal.Body>

                <Form>
                    <Container>
                        <br/>
                        <Row>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    Firmenname:
                                </Form.Label>
                                <Col sm="6" className="newOrganisationModalText">
                                    <Form.Control type="text"
                                                  onBlur={event => elem.handleOrganisationNameChange(event.target.value)}/>{elem.props.errorMessageOrganisationName}
                                </Col>
                            </Form.Group></Col>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    Stadt:
                                </Form.Label>
                                <Col sm="6" className="newOrganisationModalText">
                                    <Form.Control type="text"
                                                  onBlur={event => elem.handleCityNameChange(event.target.value)}/>{elem.props.errorMessageCityName}
                                </Col>
                            </Form.Group></Col>
                        </Row>
                        <Row>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    Straße:
                                </Form.Label>
                                <Col sm="6" className="newOrganisationModalText">
                                    <Form.Control type="text"
                                                  onBlur={event => elem.handleStreetNameChange(event.target.value)}/>{elem.props.errorMessageStreetName}

                                </Col>
                            </Form.Group></Col>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    Postleitzahl:
                                </Form.Label>
                                <Col sm="6" className="newOrganisationModalText">
                                    <Form.Control type="text"
                                                  onBlur={event => elem.handlePostCodeChange(event.target.value)}/>{elem.props.errorMessagePostCode}

                                </Col>
                            </Form.Group></Col>
                        </Row>
                        <Row>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    Straße Nr:
                                </Form.Label>
                                <Col sm="6" className="newOrganisationModalText">
                                    <Form.Control type="text"
                                                  onBlur={event => elem.handleStreetNumberChange(event.target.value)}/>{elem.props.errorMessageStreetNumber}

                                </Col>
                            </Form.Group></Col>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    Land:
                                </Form.Label>
                                <Col sm="6" className="newOrganisationModalText">
                                    <Form.Control type="text"
                                                  onBlur={event => elem.handleCountryNameChange(event.target.value)}/>{elem.props.errorMessageCountryName}

                                </Col>
                            </Form.Group></Col>
                        </Row>

                        <br/>
                        <Row>
                            <Col>
                                <Form.Group as={Row}>
                                    <Form.Label column sm="6">
                                        <h4>Admin</h4>
                                    </Form.Label>
                                    <Col sm="6">
                                    </Col>
                                </Form.Group>
                            </Col>
                        </Row>
                        <br/>

                        <Row>
                            <Col><Form.Group as={Row}>
                                <FirstNameForm defaultvalue="" props={elem.props} data={elem.props.editOrganisationData}
                                               changeState={elem.changeState}/>
                            </Form.Group></Col>
                            <Col><Form.Group as={Row}>
                                <EmailForm defaultvalue="" props={elem.props} data={elem.props.editOrganisationData}
                                           current_em="" changeState={elem.changeState}
                                           setupCompanyEmail={true}/>
                            </Form.Group></Col>
                        </Row>
                        <Row>
                            <Col><Form.Group as={Row}>
                                <LastNameForm defaultvalue="" props={elem.props} data={elem.props.editOrganisationData}
                                              changeState={elem.changeState}/>
                            </Form.Group>
                            </Col>
                            <Col><Form.Group as={Row}>
                                <ContactForm defaultvalue="" props={elem.props} data={elem.props.editOrganisationData}
                                             initialContact="" changeState={elem.changeState}/>
                            </Form.Group></Col>
                        </Row>


                        <Row>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    Produkte:
                                </Form.Label>

                            </Form.Group></Col>

                        </Row>

                        <Row>
                            <Col column sm="1">
                                <input
                                    onChange={e => elem.handleProductChange(e,'lv')}
                                    className="userdetailscheckbox"
                                    type="checkbox"
                                    id="checkbox"/>
                            </Col>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    LV-Analyse
                                </Form.Label>


                            </Form.Group>
                            </Col>
                        </Row>


                        <Row>
                            <Col column sm="1">
                                <input
                                    onChange={e => elem.handleProductChange(e,'app')}
                                    className="userdetailscheckbox"
                                    type="checkbox"
                                    id="checkbox"/>
                            </Col>
                            <Col><Form.Group as={Row}>
                                <Form.Label column sm="6">
                                    Mobile-App
                                </Form.Label>


                            </Form.Group>
                            </Col>
                        </Row>


                        <br/>
                    </Container>
                </Form>
            </Modal.Body>

            <Modal.Footer>
                <Button disabled={!elem.checkValidation()} size="lg" block variant="outline-success"
                        onClick={() =>{
                            elem.resetState({addNewOrganisationModalShow: false})
                         elem.handleNewCompanySave()
                        }}><Save/>&nbsp;&nbsp;Speichern</Button>

                <Button size="lg" variant="outline-dark" style={{width: "100%"}}
                        onClick={() => elem.resetState({addNewOrganisationModalShow: false})}><X/>
                    &nbsp;&nbsp;Abbrechen
                </Button>
            </Modal.Footer>
        </Modal>)
};

export default NewOrganisationModal